import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import type { OtherDisasterStatusRef } from "../../../../types/disaster";
import type { MouseEvent } from "react";

type OtherDisasterPopupProps = {
  otherDisasterStatuses?: OtherDisasterStatusRef[];
  id?: string | number;
};

export default function OtherDisasterPopup({
  otherDisasterStatuses,
  id = "",
}: OtherDisasterPopupProps) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  if (!otherDisasterStatuses || otherDisasterStatuses.length === 0) {
    return null;
  }

  return (
    <>
      <Button
        name="otherDisasterPopupButton"
        color="secondary"
        variant="contained"
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{ pointerEvents: "auto" }}
        endIcon={<KeyboardArrowDownIcon />}
      >
        他の対応中災害
      </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {otherDisasterStatuses.map((row, index) => (
          <MenuItem
            name="otherDisasterPopupMenuItem"
            key={`${id}_${index}`}
            onClick={() =>
              navigate(
                `/dashboard/situationcheck/report?disaster-id=${row.disaster.id}&status-id=${row.id}`
              )
            }
            sx={{ fontWeight: "bold" }}
          >
            <span>{row.disaster.name ? row.disaster.name : "名称未設定"}</span>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
